<script setup>
    import { ref, computed, onMounted, isProxy, toRaw } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import { storeToRefs } from "pinia";
    import { useSiteMenuStore } from "../../stores/sitemenu";
    import { useNavigationStore } from "../../stores/navigation";
    const { isAdminView, isMobileMenuView } = storeToRefs(useNavigationStore());
    const { $alert, $confirm } = useAlertStore();
    import { useDeviceStore } from "../../stores/device";
    import { useAlertStore } from "../../stores/alertStore";
    import _ from 'lodash'

    const route = useRoute();
    const router = useRouter();
    const siteMenuStore = useSiteMenuStore();
    const isDropdown = ref(false);
    const isBurger = ref(false);
    const alertModal = ref(null)
    const deviceStore = useDeviceStore();
    deviceStore.init();

    const menuList = computed(()=>{
        return _.filter(siteMenuStore.menuList, { menuAreaGb: '01', validYn: 'Y'}); // 01: GNB, 02: TOP
    })
    const toggleGnb = (flag) => {
        isDropdown.value = flag;

        if(flag) {
            document.querySelector('header').classList.add('on');
        } else {
            document.querySelector('header').classList.remove('on');
        }
    }

    const isCurrentRoute = (menuUrl) => {
        const _route = isProxy(route) ? toRaw(route) : route;
        return _route.fullPath.value.indexOf(menuUrl) > -1;

    }

    const onClickMenu = (childMenu) => {
        const closedMatchingMenuId = [19]; // 채용열기 // Matching > 채용 지원, 기증 장비 지원
      // const closedMatchingMenuId = [4,18,19]; // 채용닫기 // Matching > 채용 지원, 기증 장비 지원
        const closedLectureMenuId  = [15,16,17]; // 세미나, SEMI-PASS, 위탁교육의뢰
        const mobileMatchingMenuId   = [4, 18, 88, 89]; // Matching, Matcing > 상시채용관, 마이페이지 > 상시채용관현황

        if(deviceStore.isMobile && [...mobileMatchingMenuId].indexOf(childMenu.menuId) >-1) {
            $alert("PC버전에서만 서비스 이용이 가능합니다.");
            return;
        }

        if([...closedMatchingMenuId, ...closedLectureMenuId].indexOf(childMenu.menuId) >-1) {
            alertModal.value.show();
        } else {
            router.push(childMenu.menuUrl)
        }
        document.querySelector('header').classList.remove('on');
    }

</script>

<template>
  <!-- 모바일인 경우 햄버거 표시-->
  <div class="mobile_menu" @click="isBurger=!isBurger; isMobileMenuView=!isMobileMenuView; " v-show="!isBurger">
    <svg width="30" height="23" viewBox="0 0 30 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="1" fill="white"/>
      <rect y="11" width="30" height="1" fill="white"/>
      <rect y="22" width="30" height="1" fill="white"/>
    </svg>
  </div>
  <!-- GNB시작 -->
    <div class="gnb-wrap" :class="{'on':isBurger}" >
      <div class="gnb-wrap_mobile">
        <div class="mobile_menu_logo">
          <img src="/src/assets/images/logo_b.png" alt="logo" />
        </div>
        <div class="mobile_menu_close" v-show="isBurger" @click="isBurger=!isBurger; isMobileMenuView=!isMobileMenuView;">
          <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M14.559 7.05938C15.1449 6.47344 15.1449 5.52188 14.559 4.93594C13.973 4.35001 13.0215 4.35001 12.4355 4.93594L7.49961 9.87657L2.55898 4.94063C1.97305 4.35469 1.02148 4.35469 0.435547 4.94063C-0.150391 5.52657 -0.150391 6.47813 0.435547 7.06407L5.37617 12L0.440234 16.9406C-0.145703 17.5266 -0.145703 18.4781 0.440234 19.0641C1.02617 19.65 1.97773 19.65 2.56367 19.0641L7.49961 14.1234L12.4402 19.0594C13.0262 19.6453 13.9777 19.6453 14.5637 19.0594C15.1496 18.4734 15.1496 17.5219 14.5637 16.9359L9.62305 12L14.559 7.05938Z" fill="black"/>
            </g>
            <defs>
              <clipPath>
                <rect width="15" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <ul class="gnb" @mouseover="toggleGnb(true)" @mouseleave="toggleGnb(false)">
          <li :class="{'active': isCurrentRoute(siteMenu.menuUrl)}" v-for="siteMenu in menuList">
              <a href="javascript:void(0);" @click="onClickMenu(siteMenu)">{{ siteMenu.menuName }}</a>
              <ul class="sub-menu">
                  <li v-for="childMenu in siteMenu.child">
                      <a href="javascript:void(0);" @click="onClickMenu(childMenu);isBurger=false; isMobileMenuView=false;">{{ childMenu.menuName }}</a>
                  </li>
              </ul>
          </li>
      </ul>
    </div>
    <AlertModal ref="alertModal" :content="['준비중 입니다.']" />
</template>

<style lang="scss" scoped>
    @import "../../assets/scss/theme";

    .gnb-wrap {
        position: relative;
        z-index: 1;
        .gnb {
            display: flex;
            width: fit-content;
            padding-top: 4px;
            margin: 0 0 0 auto;
            > li {
                position: relative;
                font-family: 'Inter', sans-serif;
                @include font-size_md;
                padding: 0 50px;
                &.active, &:hover {
                    > a {
                        font-weight: 700;
                        &:after {
                            transform: scaleX(1);
                            transition-duration: 0.2s;
                        }
                    }
                }
                &:last-child {
                    text-align: right;
                    padding-right: 0;
                    .sub-menu {
                        padding-left: 50px;
                    }
                }
                &:hover {
                    .sub-menu {
                        a {
                            font-weight: 700;
                        }
                    }
                }
                > a {
                    position: relative;
                    display: block;
                    width: fit-content;
                    min-width: 112px;
                    height: 52px;
                    text-align: center;
                    margin: auto;
                    &:after {
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 2px;
                        background: #10117E;
                        transform: scaleX(0);
                        transition-duration: 0.2s;
                    }
                }
                .sub-menu {
                    display: none;
                    position: absolute;
                    right: 0;
                    width: 100%;
                    height: 376px;
                    padding: 30px 0;
                    text-align: center;
                    li {
                        margin-bottom: 20px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        &:hover {
                            a {
                                color: #10117E;
                            }
                        }
                    }
                }
            }
        }
    }
</style>